'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubscribersController = function () {
  function SubscribersController(NewsletterDataProvider) {
    "ngInject";

    (0, _classCallCheck3.default)(this, SubscribersController);
    this.NewsletterDataProvider = NewsletterDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = { 10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All' };
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getSubscribers();
  }

  (0, _createClass3.default)(SubscribersController, [{
    key: 'getSortRecors',
    value: function getSortRecors(field, order_type, col, colTopDown) {
      this.field = field;
      this.order_type = order_type;
      this.col = col;
      this.colTopDown = colTopDown;
      this.getSubscribers();
    }
  }, {
    key: 'getSubscribers',
    value: function getSubscribers() {
      var vm = this;
      var data = {};
      var searchData = {};
      searchData.name = vm.name;
      searchData.email = vm.email;
      data.searchData = searchData;
      data.currentPage = vm.currentPage;
      data.pageLimit = vm.pageLimit;
      data.field = vm.field;
      data.order_type = vm.order_type;
      vm.NewsletterDataProvider.getSubscribers(data, searchData).then(function (result) {
        vm.subscribers = result.data;
        vm.subscribersTotal = result.total;
        vm.selectall = false;
      });
    }
  }, {
    key: 'removeSubscriber',
    value: function removeSubscriber(id) {
      if (confirm("Are you sure to delete!") !== true) {
        return false;
      }
      var vm = this;
      vm.NewsletterDataProvider.removeSubscriber(id).then(function (res) {
        vm.getSubscribers();
      });
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      this.name = '';
      this.code = '';
      this.type = '';
      this.price_from = '';
      this.price_to = '';
      this.used_count = '';
      this.status = '';
      this.getSubscribers();
    }
  }]);
  return SubscribersController;
}();

// WEBPACK FOOTER //


exports.default = SubscribersController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/components/subscribers/controller.js
 **/